/**
 * Enum for DataTable's ordering signatures.
 */
export enum Order {
  'DESCENDING' = 1,
  'ASCENDING' = -1,
}
